import { render, staticRenderFns } from "./SubscriptionBlockedModal.vue?vue&type=template&id=2a62d961&scoped=true"
import script from "./SubscriptionBlockedModal.vue?vue&type=script&lang=js"
export * from "./SubscriptionBlockedModal.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionBlockedModal.vue?vue&type=style&index=0&id=2a62d961&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a62d961",
  null
  
)

export default component.exports